import 'slick-carousel/slick/slick.min';
import 'jquery-match-height/dist/jquery.matchHeight-min';
import Utils from '@lauragaistourisme/js/services/utils';

export default class WpetList {

    static #slick_element;

    static #wpet_offer_slider_list_settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false
    };

    constructor() {
        WpetList.view_mode();
        WpetList.slick();
        WpetList.match_height();
        WpetList.filters();
        WpetList.link_offer();
        WpetList.offer_meta_mobile();
        WpetList.initialize_trigger();
    }

    static view_mode() {
        const trigger = '[data-trigger="wpet-mode"]',
            $element = $('[data-id="wpet-list"]');

        if (trigger.length > 0) {
            $(document).on('click', trigger, function (e) {
                e.preventDefault();

                const mode = $(this).attr('data-wpet-switch-mode');
                $element.attr('data-wpet-current-mode', mode);
                window.wpet_map_object.mapObject.resize();

                $(document).trigger('wpet_change_mode');
            });
        }
    }

    static number_results(data) {
        const $element = $('[data-id="wpet-list-total-offer"]');
        $element.text(data.total_global);
    }

    static number_current_engine() {
        const filters_total = $('[data-filters-total]').data('filters-total'),
            $element = $('[data-id="wpet-list-total-current-engine"]');

        if (filters_total > 0) {
            $element.text('(' + filters_total + ')');
        } else {
            $element.text('');
        }
    }

    static slick() {
        const $trigger = $('[data-trigger="wpet-offer-slider"]');
        WpetList.#slick_element = $trigger.slick(WpetList.#wpet_offer_slider_list_settings);
    }

    static match_height() {
        const $element = $('[data-mh]');

        if ($element.length > 0) {
            $element.matchHeight();
        }
    }

    static filters() {
        let trigger = '[data-trigger="wpet-list-filters-button"]',
            close = '[data-trigger="wpet-list-results-filters-list-close"]',
            $element = $('body');

        $(document).on('click', trigger, function (e) {
            e.preventDefault();
            $element.addClass('isWpetFiltersOpen');
        });

        $(document).on('click', close, function (e) {
            e.preventDefault();
            $element.removeClass('isWpetFiltersOpen');
        });

        $(document).on('wpet_ajax_build', function () {
            $element.removeClass('isWpetFiltersOpen');
        });
    }

    static link_offer() {
        const trigger = '[data-trigger="wpet-click"]';

        if (trigger.length > 0) {
            $(document).on('click', trigger, (e) => {
                if (!$(e.target).hasClass('slick-arrow')) {
                    window.location = $(e.currentTarget).parents('[data-id="wpet-offer"]').find('[data-id="wpet-offer-link"]').attr('href');
                }
            });
        }
    }

    static offer_meta_mobile() {
        const trigger = '[data-trigger="wpet-offer-mobile-button"]',
            element = '[data-id="wpet-offer-mobile-list"]';

        $(document).on('click', trigger, function (e) {
            e.preventDefault();
            $(this).parents('[data-id="wpet-offer"]').find(element).toggle();
        });
    }

    static form_select() {
        $('select').parent().not('.formSelect').children('select').wrap('<div class="formSelect"></div>');
    }

    static back_to_top() {
        $('html, body').animate({
            scrollTop: $('[data-id="wpet-list"]').offset().top
        }, 300);
    }

    static initialize_trigger() {
        $(document).on('wpet_ajax_build', (e, data) => {
            WpetList.form_select();
            WpetList.slick();
            Utils.lazy();
            WpetList.match_height();
            WpetList.back_to_top();
            WpetList.number_results(data);
            WpetList.number_current_engine();
        });

        $(document).on('wpet_ajax_build wpet_ajax_only_form', () => {
            WpetList.form_select();
        });

        $(document).on('wpet_change_mode', () => {
            WpetList.#slick_element.slick('unslick');
            WpetList.slick();
            WpetList.match_height();
        });
    }
};

